import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface CmykProps {}

const Cmyk: FC<CmykProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'cmyk'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default Cmyk
